<template>
    <div class="agreement">
        <div v-show="!queryAgreementListLoading" v-for="agreement in agreementList" :key="agreement.id">
            <router-link
                :key="agreement.id"
                :to="{ path: agreementContentRoute, query: { id: agreement.id } }" target="_blank">
                《{{ agreement.name }}》
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "AgreementList",
    props: {
        queryAgreementListLoading: {
            type: Boolean,
            default: false
        },
        agreementList: {
            type: Array,
            default: function () {
                return [];
            }
        }
    },
    computed: {
        agreementContentRoute() {
            return '/sithMes/agreement/agreementContent'
        },
    }
}
</script>

<style scoped>
.agreement {
    display: inline-block;
}
</style>
